export default function ContactSection({ social }) {
  const socials = [
    { icon: "fa-phone",           href: "tel:+32488051685",     label: "+32 488 051 685",         color: "#4ade80" },
    { icon: "fa-envelope",        href: social.mail,            label: "wolvesbxl@hotmail.com",   color: "#60a5fa", solid: true },
    { icon: "fa-brands fa-whatsapp",   href: social.wa,    label: "WhatsApp",                color: "#25d366" },
    { icon: "fa-brands fa-facebook",   href: social.fb,    label: "Wolves Judo Bruxelles",   color: "#1877f2" },
    { icon: "fa-brands fa-instagram",  href: social.ig,    label: "@wolvesbxl",              color: "#e1306c" },
    { icon: "fa-brands fa-tiktok",     href: social.tt,    label: "@wolvesbxl",              color: "#fff" },
  ];

  return (
    <section className="section alt">
      <div className="container">
        <div className="contact-layout">

          <div className="contact-card" id="contact" data-reveal="left">
            <span className="section-label">💬 Contact</span>
            <h2 className="section-title">On est là</h2>
            <p className="contact-lead">
              Le plus simple : <strong>écris-nous sur WhatsApp</strong>.<br />
              On répond vite.
            </p>

            <ul className="contact-list-premium">
              {socials.map((s) => (
                <li key={s.href}>
                  <a href={s.href} target={s.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer"
                     style={{ "--c": s.color }}>
                    <span className="cl-icon" style={{ background: s.color + "18", color: s.color }}>
                      <i className={s.solid ? `fa-solid ${s.icon}` : s.icon} />
                    </span>
                    <span className="cl-label">{s.label}</span>
                    <i className="fa-solid fa-arrow-right cl-arrow" />
                  </a>
                </li>
              ))}
            </ul>

            <div className="contact-addr">
              <div className="k"><i className="fa-solid fa-location-dot" /> Adresse</div>
              <div className="v">Rue Léon Autrique 4, 1081 Koekelberg, Belgique</div>
            </div>

            <a className="btn-primary" href={social.wa} target="_blank" rel="noreferrer">
              <i className="fa-brands fa-whatsapp" /> Ouvrir WhatsApp
            </a>
          </div>

          <div className="plan-card" id="plan" data-reveal="right">
            <span className="section-label">📍 Localisation</span>
            <h2 className="section-title">Plan</h2>
            <div className="map-wrap">
              <iframe
                title="Plan Wolves Judo Bruxelles"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps?q=Rue%20L%C3%A9on%20Autrique%204%2C%201081%20Koekelberg%2C%20Belgique&output=embed"
              />
            </div>
            <a
              className="btn-primary"
              href="https://www.google.com/maps?q=Rue%20L%C3%A9on%20Autrique%204%2C%201081%20Koekelberg%2C%20Belgique"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa-solid fa-map-location-dot" /> Ouvrir dans Maps
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}
